// extracted by mini-css-extract-plugin
module.exports = {"title":"PageProfile__title__25e1r","subtitle":"PageProfile__subtitle__3LMl2"};